import { styled } from '@mui/material/styles';
import MDInput from 'components/atoms/MDInput/MDInput';

export const StyledDateInput = styled(MDInput)(({ theme }) => ({}));
